import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { OverviewListComponent } from './modules/overview/overview-list/overview-list.component';
import { DetailPageComponent } from './modules/detail/detail-page/detail-page.component';
import { NewEventFormComponent } from './modules/create-event/new-event-form/new-event-form.component';
import { AuthCallbackComponent } from './modules/auth/auth-callback/auth-callback.component';
import { LoginComponent } from './modules/auth/login/login.component';
import { AuthGuard } from './guards/auth.guard';
import { SilentRefreshComponent } from './modules/auth/silent-refresh/silent-refresh.component';
import { StreappersComponent } from './modules/streapper/streappers/streappers.component';
import { AdsOverviewComponent } from './modules/ads/ads-overview/ads-overview.component';
import { AccessDeniedComponent } from './modules/auth/access-denied/access-denied.component';
import { CreateAdComponent } from './modules/ads/create-ad/create-ad.component';
import { PromoOverviewComponent } from './modules/ads/promo-overview/promo-overview.component';
import { PromoDetailComponent } from './modules/ads/promo-detail/promo-detail.component';
import { VideoComponent } from './modules/video/video.component';
import { OverviewMapComponent } from './modules/overview/overview-map/overview-map.component';
import { Overview112Component } from './modules/overview/overview-112/overview-112.component';
import { P2000DetailPageComponent } from './modules/detail/p2000-detail-page/p2000-detail-page.component';
import { Four04Component } from './modules/statuscodes/four04/four04.component';
import { UserComponent } from './modules/user/user/user.component';
import { InfoComponent } from './modules/info/info.component';
import { StreappPaymentSuccessComponent } from './components/streapp-payment-success/streapp-payment-success.component';
import { StreappPaymentCancelComponent } from './components/streapp-payment-cancel/streapp-payment-cancel.component';
import { SebbieOverviewComponent } from './modules/sebbies/sebbie-overview/sebbie-overview.component';
import { TaskDetailComponent } from './modules/sebbies/task-detail/task-detail.component';
import { CdkStepper } from '@angular/cdk/stepper';
import { StreapperDetailComponent } from './modules/streapper/streapper-detail/streapper-detail.component';
import { ProfileComponent } from './modules/profile/profile/profile.component';
import { SubscriptionOverviewComponent } from './modules/subscription/subscription-overview/subscription-overview.component';
import { streapperRoles } from './constants/streapperRoles';
import { EditEventFormComponent } from './modules/create-event/edit-event-form/edit-event-form.component';

const routes: Routes = [
  {
    path: 'auth-callback',
    component: AuthCallbackComponent,
    data: { hidelayout: true },
  },
  { path: 'silent-refresh.html', component: SilentRefreshComponent },
  { path: 'login', component: LoginComponent, data: { hidelayout: true } },
  { path: 'video', component: VideoComponent, data: { hidelayout: true } },
  {
    path: '',
    component: OverviewListComponent,
  },
  {
    path: 'kaart',
    component: OverviewMapComponent,
  },
  {
    path: 'lokaal',
    component: OverviewListComponent,
  },
  {
    path: '112',
    component: Overview112Component,
  },
  {
    path: 'detail/:id',
    component: DetailPageComponent,
  },
  {
    path: '112/detail',
    component: P2000DetailPageComponent,
  },
  {
    path: 'profile',
    canActivate: [AuthGuard],
    component: ProfileComponent,
  },
  {
    path: 'create-event',
    canActivate: [AuthGuard],
    component: NewEventFormComponent,
    providers: [{ provide: CdkStepper, useClass: CdkStepper }],
  },
  {
    path: 'edit-event/:id',
    canActivate: [AuthGuard],
    component: EditEventFormComponent,
    providers: [{ provide: CdkStepper, useClass: CdkStepper }],
  },
  {
    path: 'info',
    component: InfoComponent,
  },
  {
    path: 'over-ons',
    redirectTo: 'info',
  },
  {
    path: 'terms',
    redirectTo: 'info',
  },
  {
    path: 'contact',
    redirectTo: 'info',
  },
  {
    path: 'streappers',
    component: StreappersComponent,
  },
  {
    path: 'streappers/detail',
    component: StreapperDetailComponent,
  },
  {
    path: 'users/detail',
    component: UserComponent,
  },
  {
    path: 'subscriptions',
    canActivate: [AuthGuard],
    component: SubscriptionOverviewComponent,
  },
  {
    path: 'ads',
    canActivate: [AuthGuard],
    data: { roles: ['Ads'] },
    component: AdsOverviewComponent,
  },
  {
    path: 'promos',
    canActivate: [AuthGuard],
    data: { roles: ['Ads'] },
    component: PromoOverviewComponent,
  },
  {
    path: 'create-ad',
    canActivate: [AuthGuard],
    data: { roles: ['Ads'] },
    component: CreateAdComponent,
  },
  {
    path: 'promo/:id',
    component: PromoDetailComponent,
  },
  {
    path: 'promo/:id/:type',
    component: PromoDetailComponent,
  },
  {
    path: 'payment-success',
    component: StreappPaymentSuccessComponent,
  },
  { path: 'payment-cancelled',
    component: StreappPaymentCancelComponent 
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'ranglijst',
    component: SebbieOverviewComponent,
  },
  {
    path: 'taken',
    canActivate: [AuthGuard],
    data: { roles: streapperRoles },
    component: TaskDetailComponent
  },
  { path: '**', component: Four04Component },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
